import { makeAutoObservable } from 'mobx';
import { ExchangeRatesApi } from '../../api/ExchangeRatesApi';
import { ExchangeRate } from '../models/ExchangeRate';

export class ExchangeRatesStore {
  groupExchangeRates: Map<number, ExchangeRate[]> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  loadGroupRates = (
    groupId: number,
    force: boolean = false
  ): Promise<ExchangeRate[]> => {
    if (this.groupExchangeRates.has(groupId) && !force) {
      return Promise.resolve(this.groupExchangeRates.get(groupId));
    }

    return ExchangeRatesApi.getExchangeRates(groupId).then(rates => {
      const parsedRates = rates.map(rate => ExchangeRate.fromApi(rate));
      this.groupExchangeRates.set(groupId, parsedRates);
      return parsedRates;
    });
  };

  getGroupRates = (groupId: number): ExchangeRate[] => {
    return this.groupExchangeRates.get(groupId);
  };
}
